import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { provideComponent, useDataItem } from "scrivito"
import { KpiCard } from "shared/ui/kpi-card/KpiCard"

import { ProjectsKpiWidget } from "./ProjectsKpiWidgetClass"

provideComponent(ProjectsKpiWidget, () => {
  const { t } = useTranslation()

  const kpiData = useDataItem("ProjectKPIs")

  const projectsCount = useMemo(() => {
    return {
      total: kpiData?.get("totalProjects") as number,
      last7Days: kpiData?.get("last7") as number,
      last30Days: kpiData?.get("last30") as number
    }
  }, [kpiData])

  return (
    <KpiCard.Root>
      <KpiCard.Title title={t("KPIs.Project.Projects")} />
      <KpiCard.DataValue value={projectsCount.total} />

      <KpiCard.Title title={t("KPIs.Project.NewProjects")} />
      <KpiCard.DataList
        data={[
          { label: t("KPIs.Last7Days"), value: projectsCount.last7Days },
          { label: t("KPIs.Last30Days"), value: projectsCount.last30Days }
        ]}
      />
    </KpiCard.Root>
  )
})
